import {DatabaseCode, toDatabaseCode} from "./database-code";

export type ScadaMode = DatabaseCode

const enabled: ScadaMode = {
  code: 'ENABLED',
  displayValue: {
    id: 'common.entity.scadamode.enabled',
    defaultMessage: 'Enabled',
  },
};

const disabled: ScadaMode = {
  code: 'DISABLED',
  displayValue: {
    id: 'common.entity.scadamode.disabled',
    defaultMessage: 'Disabled',
  },
};

const unknown: ScadaMode = {
  code: 'UNKNOWN',
  displayValue: {
    id: 'common.entity.scadamode.unknown',
    defaultMessage: 'Unknown',
  },
};

export const scadaMode = {
  enabled,
  disabled,
  unknown,
};

export const scadaModes = Object.values(scadaMode);

export const toScadaMode = (code: string): ScadaMode => toDatabaseCode(code, scadaModes);
export const toScadaModeSafely = (code: string | undefined): ScadaMode | undefined => code ? toDatabaseCode(code, scadaModes) : undefined;
